import { useEffect, useState } from 'react'
import { AnalyticsConsentCard } from './analytics/AnalyticsConsent'
import { HomepageV3Footer, HomepageV3Header } from './components/HomepageV3Chrome'
import { cartBoxCount } from './order/cartStorage'

const mascot = '/assets/brand/sg-mascot-head-approved.png'

export default function PublicNotFoundPage() {
  const [cartCount, setCartCount] = useState(() => cartBoxCount())
  const activeHref = typeof window !== 'undefined' && /^\/vault\/?$/.test(window.location.pathname) ? '/vault' : '__not-found__'

  useEffect(() => {
    const refreshCart = () => setCartCount(cartBoxCount())
    window.addEventListener('storage', refreshCart)
    const timer = window.setInterval(refreshCart, 500)
    return () => {
      window.clearInterval(timer)
      window.removeEventListener('storage', refreshCart)
    }
  }, [])

  return (
    <div className="sg-v3 sg-public-error-page">
      <a className="skip-link" href="#main-content">Skip to main content</a>
      <HomepageV3Header cartCount={cartCount} activeHref={activeHref} />
      <main className="sg-error-404" id="main-content" tabIndex={-1}>
        <div className="sg-v3-shell sg-error-404__layout">
          <div className="sg-error-404__copy">
            <p className="sg-error-404__pill">404 ERROR</p>
            <h1>THIS PAGE GOT GREMLINED.</h1>
            <p className="sg-error-404__body">Whatever you were looking for has wandered off with the crumbs.</p>
            <div className="sg-error-404__actions">
              <a className="sg-v3-button sg-v3-button--pink" href="/">BACK TO HOME<span className="sg-v3-arrow" aria-hidden="true">→</span></a>
              <a className="sg-v3-button sg-v3-button--outline" href="/order">BUILD A BOX<span className="sg-v3-arrow" aria-hidden="true">→</span></a>
            </div>
          </div>
          <div className="sg-error-404__visual" aria-hidden="true">
            <span className="sg-error-404__number">404</span>
            <img src={mascot} alt="" />
          </div>
        </div>
      </main>
      <HomepageV3Footer />
      <AnalyticsConsentCard />
    </div>
  )
}
